
import imageIcon from "../assets/images/social_media_icons/icons8-image-96.png"

export function overrideUndefinedImage(type, imgSource, typeSource) {
    if(type === "image" && typeSource === "image" && imgSource.endsWith("undefined.png")) {
      return imageIcon;
    }
    return imgSource;
  }